import { render } from "./NotificationContainer.vue?vue&type=template&id=0173ee1f&scoped=true"
import script from "./NotificationContainer.vue?vue&type=script&lang=js"
export * from "./NotificationContainer.vue?vue&type=script&lang=js"

import "./NotificationContainer.vue?vue&type=style&index=0&id=0173ee1f&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0173ee1f"]])

export default __exports__